const MODAL_ELE_TAG = 'descope-modal';

export { MODAL_ELE_TAG };
//# sourceMappingURL=constants.js.map
